import request from '@/utils/request';
export const defaultDealersTransporterData = {
  id: 0,
  enabled: true,
  isPrimary: false,
  freightPerCarton: 0,
  transporterId: null,
  transporter: {
    id: null
  },
  dealerId: 0,
  dealer: {
    id: null
  }
};
export const getDealersTransporters = params => request({
  url: '/dealers-transporters',
  method: 'get',
  params
});
export const getDealersTransporterById = id => request({
  url: `/dealers-transporters/${id}`,
  method: 'get'
});
export const updateDealersTransporter = (id, data) => request({
  url: `/dealers-transporters/${id}`,
  method: 'patch',
  data
});
export const deleteDealersTransporter = id => request({
  url: `/dealers-transporters/${id}`,
  method: 'delete'
});
export const createDealersTransporter = data => request({
  url: '/dealers-transporters/',
  method: 'post',
  data
});